<template>
  <div class="container">
    <h2 class="text-center">Revolutionize Your Parts Invoice Processing with AI-Powered Automation</h2>
    <p>
      Tired of manually entering part invoices into your Auto Collision Management System? Save time, reduce errors, and streamline your workflow with
      our <strong>AI-Powered Invoice Processing Solution</strong>—designed specifically for Auto Collision Centers.
    </p>

    <h3>How It Works:</h3>
    <ul>
      <li><strong>Scan & Upload</strong> – Simply scan your paper invoices when checking in parts and upload them to our secure web app.</li>
      <li>
        <strong>AI-Powered OCR & Data Standardization</strong> – Our cutting-edge AI extracts and interprets key invoice details, transforming them
        into a clean, standardized format.
      </li>
      <li>
        <strong>Seamless Copy-Paste Integration</strong> – Instantly copy extracted values with a single click and paste them directly into your Auto
        Collision Management Software.
      </li>
    </ul>

    <h3>Why Auto Collision Centers Love It:</h3>
    <ul class="custom-list">
      <li>✅ <strong>Eliminate Manual Data Entry</strong> – No more tedious typing; just scan, upload, and copy.</li>
      <li>✅ <strong>Auto-Fill</strong> – Have Invoices AI auto-fill the invoice fields within CCC One.</li>
      <li>✅ <strong>Reduce Errors & Improve Accuracy</strong> – AI ensures clean, structured data every time.</li>
      <li>✅ <strong>Save Time & Increase Efficiency</strong> – Focus on running your shop, not entering invoices.</li>
      <li>✅ <strong>Secure & Cloud-Based</strong> – Access and process invoices anytime, anywhere.</li>
      <li>✅ <strong>Flexible Pricing</strong> – <em>Subscription-based access</em> plus a <em>pay-per-scan</em> model that fits your needs.</li>
    </ul>

    <div class="cta mt-5">
      <p><strong>Start Streamlining Your Parts Check-in Process Today!</strong></p>
      <a href="#" @click="signUp">Get Started Now</a>
    </div>
    <div class="row mt-5">
      <div class="col-4 text-center">
        <button class="btn btn-primary btn-sm" @click="pricing">Learn More About Pricing</button>
      </div>
      <div class="col"></div>
      <div class="col-4 text-center">
        <button class="btn btn-primary btn-sm" @click="agreement">License Agreement</button>
      </div>
    </div>
  </div>
  <DialogPricing v-model="actionPricing" @closing="closeModal" />
  <DialogAgreement v-model="actionAgreement" @closing="closeModal" />
</template>
<script>
import DialogAgreement from './DialogAgreement.vue'
import DialogPricing from './DialogPricing.vue'
export default {
  name: 'LearnMoreDetails',
  components: {
    DialogAgreement,
    DialogPricing
  },
  data() {
    return {
      actionPricing: false,
      actionAgreement: false
    }
  },
  methods: {
    closeModal() {
      this.actionPricing = null
      this.actionAgreement = null
    },
    signUp() {
      this.$router.push('/onboard')
    },
    pricing() {
      this.actionPricing = {
        title: 'Invoices AI Pricing'
      }
    },
    agreement() {
      this.actionAgreement = {
        title: 'Software License Agreement'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  max-width: 80%;
  margin: 50px auto;
  padding: 20px;
  background: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
h1,
h2 {
  color: #0073e6;
}
ul {
  padding-left: 20px;
}
.cta {
  text-align: center;
  margin-top: 20px;
}
.cta a {
  display: inline-block;
  padding: 10px 20px;
  color: #fff;
  background-color: #0d6efd;
  text-decoration: none;
  font-size: 18px;
  border-radius: 5px;
  transition: background 0.3s;
}
.cta a:hover {
  background-color: #005bb5;
}
.custom-list {
  list-style: none;
  padding-left: 0;
}
</style>
